import { Component, OnInit, Input } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Router } from "@angular/router";
// services
import { ErrorHandler } from "../../../services/error-handler.service";
// models
import { AppState } from "../../../../booking/models/app-state.interface";
import { ModalData } from "../../../models/modal.interface";
// ngrx store
import { Store } from "@ngrx/store";

@Component({
  selector: "app-remove-service-modal",
  templateUrl: "./remove-service-modal.component.html",
  styleUrls: ["./remove-service-modal.component.scss"],
})
export class RemoveServiceModalComponent implements OnInit {
  @Input()
  modalData: ModalData;

  public modalList: Array<any> = [];

  constructor(
    private _errorService: ErrorHandler,
    public appStore: Store<AppState>
  ) {}

  ngOnInit() {}

  close(event) {
    this._errorService.modalItem$.next("remove");
  }

  removeService() {
    this.close('event');
    this._errorService.removeD2dService$.next(true);
  }
}
